import r from "../managers/braze-instance.js";
import rr from "./content-cards-provider-factory.js";
export function requestContentCardsRefresh(e, t) {
  if (r.rr()) return rr.o().fi(e, t, !0);
}